import React, { useState, useEffect } from "react";
import { connectionManager } from "../api/api";
import { healthApi } from "@/api/healthApi";

const TestPage: React.FC = () => {
  const [apiUrl, setApiUrl] = useState("");
  const [backendStatus, setBackendStatus] = useState("Testing...");
  const [error, setError] = useState<string | null>(null);
  const [connectionStatus, setConnectionStatus] = useState<any>(connectionManager.getStatus());

  useEffect(() => {
    const testBackend = async () => {
      try {
        // Show what API URL is configured
        const runtimeUrl = window._env_ && window._env_.REACT_APP_API_URL;
        const buildUrl = process.env.REACT_APP_API_URL;
        const configuredUrl = runtimeUrl || buildUrl || "/api";
        setApiUrl(configuredUrl);

        // Try to fetch from backend
        const data = await healthApi.getHealth(configuredUrl);
        if (data) {
          setBackendStatus("✅ Backend is reachable!");
          console.log("Backend response:", data);
        }
      } catch (err: unknown) {
        setError(err instanceof Error ? err.message : String(err));
        setBackendStatus("❌ Cannot reach backend");
        console.error("Backend error:", err);
      }
    };

    testBackend();

    // Subscribe to connection manager updates
    const unsubscribe = connectionManager.addListener((status) => {
      setConnectionStatus(status);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <div style={{ padding: "40px", fontFamily: "Arial, sans-serif" }}>
      <h1>🔍 NS2 Nimbusmind - Debug Page</h1>

      <div
        style={{ background: "#f0f0f0", padding: "20px", marginTop: "20px", borderRadius: "8px" }}
      >
        <h2>Configuration</h2>
        <p>
          <strong>API URL:</strong> {apiUrl}
        </p>
        <p>
          <strong>Runtime Config:</strong>{" "}
          {window._env_ && window._env_.REACT_APP_API_URL
            ? window._env_.REACT_APP_API_URL
            : "Not set"}
        </p>
        <p>
          <strong>Build-time Env:</strong> {process.env.REACT_APP_API_URL || "Not set"}
        </p>
        <p>
          <strong>Current Location:</strong> {window.location.href}
        </p>
      </div>

      <div
        style={{ background: "#e3f2fd", padding: "20px", marginTop: "20px", borderRadius: "8px" }}
      >
        <h2>Backend Status</h2>
        <p style={{ fontSize: "18px" }}>{backendStatus}</p>
        {error && (
          <div
            style={{
              background: "#ffebee",
              padding: "10px",
              marginTop: "10px",
              borderRadius: "4px",
            }}
          >
            <strong>Error:</strong> {error}
          </div>
        )}
      </div>

      <div
        style={{
          background: connectionStatus.isCircuitOpen
            ? "#ffebee"
            : connectionStatus.failureCount > 0
              ? "#fff3e0"
              : "#e8f5e9",
          padding: "20px",
          marginTop: "20px",
          borderRadius: "8px",
        }}
      >
        <h2>Connection Manager Status</h2>
        <p>
          <strong>Failure Count:</strong> {connectionStatus.failureCount} /{" "}
          {connectionStatus.maxFailures}
        </p>
        <p>
          <strong>Circuit Status:</strong>{" "}
          {connectionStatus.isCircuitOpen ? "🔴 OPEN (Requests Blocked)" : "🟢 CLOSED (Normal)"}
        </p>
        <p>
          <strong>Can Make Request:</strong> {connectionStatus.canMakeRequest ? "✅ Yes" : "❌ No"}
        </p>
        {connectionStatus.lastFailureTime && (
          <p>
            <strong>Last Failure:</strong>{" "}
            {new Date(connectionStatus.lastFailureTime).toLocaleString()}
          </p>
        )}
        <button
          onClick={() => connectionManager.reset()}
          style={{
            padding: "8px 16px",
            fontSize: "14px",
            background: "#4caf50",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            marginTop: "10px",
          }}
        >
          Reset Connection Manager
        </button>
      </div>

      <div
        style={{ background: "#fff3e0", padding: "20px", marginTop: "20px", borderRadius: "8px" }}
      >
        <h2>✅ If you see this page, React is working!</h2>
        <p>The issue is likely with API calls or specific components.</p>
        <p>
          <strong>Circuit Breaker Info:</strong> After 5 consecutive API failures, the webclient
          will stop making requests to prevent overload. Ensure backend is running and accessible.
        </p>
        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
          <button
            onClick={() => (window.location.href = "/")}
            style={{
              padding: "10px 20px",
              fontSize: "16px",
              background: "#2196f3",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Go Back to Dashboard
          </button>
          <button
            onClick={() => (window.location.href = "/test/notifications")}
            style={{
              padding: "10px 20px",
              fontSize: "16px",
              background: "#9c27b0",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Notification Helper
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestPage;
